'use strict';

exports.__esModule = true;
exports.LOGIN_VALIDATION_FAILED = exports.LOGIN_SET_VALID_EMAIL = exports.LOGIN_REMEMBER_ME_CHECKED = exports.LOGIN_EMAIL_CHANGE = exports.SHOW_LOGIN = exports.SET_VALID_POLICY_NUMBER = exports.SET_VALID_CLAIM_NUMBER = exports.SET_VALID_PHONE = exports.VALIDATION_FAILED = exports.SUBMIT_REQUEST = exports.VISIT_REASON_CHANGE = exports.INSURANCE_SELECTED = exports.VISITED_OPTION_SELECTED = exports.POLICY_NUMBER_CHANGE = exports.CLAIM_NUMBER_CHANGE = exports.PHONE_CHANGE = exports.CLOSE_BOOK_APPOINTMENT_MODAL = exports.OPEN_BOOK_APPOINTMENT_MODAL = undefined;

var _doctifyUtils = require('doctify-utils');

var OPEN_BOOK_APPOINTMENT_MODAL = exports.OPEN_BOOK_APPOINTMENT_MODAL = 'BOOK_APPOINTMENT_MODAL_ACTIONS:OPEN_BOOK_APPOINTMENT_MODAL'; // This is an example of the actions for a component that the page will compose.
// It should export string constants for its action types (with a prefix e.g. SEARCH_BAR:GET_LOCATIONS)
// and use those in the action methods (e.g. getLocationAutocomplete).

// Things with API calls will use createAction as commented out below. See doctify/home-page.

var CLOSE_BOOK_APPOINTMENT_MODAL = exports.CLOSE_BOOK_APPOINTMENT_MODAL = 'BOOK_APPOINTMENT_MODAL_ACTIONS:CLOSE_BOOK_APPOINTMENT_MODAL';
var PHONE_CHANGE = exports.PHONE_CHANGE = 'BOOK_APPOINTMENT_MODAL_ACTIONS:PHONE_CHANGE';
var CLAIM_NUMBER_CHANGE = exports.CLAIM_NUMBER_CHANGE = 'BOOK_APPOINTMENT_MODAL_ACTIONS:CLAIM_NUMBER_CHANGE';
var POLICY_NUMBER_CHANGE = exports.POLICY_NUMBER_CHANGE = 'BOOK_APPOINTMENT_MODAL_ACTIONS:POLICY_NUMBER_CHANGE';
var VISITED_OPTION_SELECTED = exports.VISITED_OPTION_SELECTED = 'BOOK_APPOINTMENT_MODAL_ACTIONS:VISITED_OPTION_SELECTED';
var INSURANCE_SELECTED = exports.INSURANCE_SELECTED = 'BOOK_APPOINTMENT_MODAL_ACTIONS:INSURANCE_SELECTED';
var VISIT_REASON_CHANGE = exports.VISIT_REASON_CHANGE = 'BOOK_APPOINTMENT_MODAL_ACTIONS:VISIT_REASON_CHANGE';
var SUBMIT_REQUEST = exports.SUBMIT_REQUEST = 'BOOK_APPOINTMENT_MODAL_ACTIONS:SUBMIT_REQUEST';
var VALIDATION_FAILED = exports.VALIDATION_FAILED = 'BOOK_APPOINTMENT_MODAL_ACTIONS:VALIDATION_FAILED';
var SET_VALID_PHONE = exports.SET_VALID_PHONE = 'BOOK_APPOINTMENT_MODAL_ACTIONS:SET_VALID_PHONE';
var SET_VALID_CLAIM_NUMBER = exports.SET_VALID_CLAIM_NUMBER = 'BOOK_APPOINTMENT_MODAL_ACTIONS:SET_VALID_CLAIM_NUMBER';
var SET_VALID_POLICY_NUMBER = exports.SET_VALID_POLICY_NUMBER = 'BOOK_APPOINTMENT_MODAL_ACTIONS:SET_VALID_POLICY_NUMBER';

var SHOW_LOGIN = exports.SHOW_LOGIN = 'BOOK_APPOINTMENT_MODAL_ACTIONS:SHOW_LOGIN';

var LOGIN_EMAIL_CHANGE = exports.LOGIN_EMAIL_CHANGE = 'BOOK_APPOINTMENT_MODAL_ACTIONS:LOGIN_EMAIL_CHANGE';
var LOGIN_REMEMBER_ME_CHECKED = exports.LOGIN_REMEMBER_ME_CHECKED = 'BOOK_APPOINTMENT_MODAL_ACTIONS:LOGIN_REMEMBER_ME_CHECKED';
var LOGIN_SET_VALID_EMAIL = exports.LOGIN_SET_VALID_EMAIL = 'BOOK_APPOINTMENT_MODAL_ACTIONS:LOGIN_SET_VALID_EMAIL';
var LOGIN_VALIDATION_FAILED = exports.LOGIN_VALIDATION_FAILED = 'BOOK_APPOINTMENT_MODAL_ACTIONS:LOGIN_VALIDATION_FAILED';

var BookAppointmentModalActions = {
	openBookAppointmentModal: function openBookAppointmentModal(time, practice) {
		return {
			type: OPEN_BOOK_APPOINTMENT_MODAL,
			time: time,
			practice: practice
		};
	},
	closeModal: function closeModal() {
		return {
			type: CLOSE_BOOK_APPOINTMENT_MODAL
		};
	},
	onPhoneChange: function onPhoneChange(phone) {
		return {
			type: PHONE_CHANGE,
			phone: phone
		};
	},
	onVisitedOptionSelected: function onVisitedOptionSelected(option) {
		return {
			type: VISITED_OPTION_SELECTED,
			option: option
		};
	},
	onInsuranceSelected: function onInsuranceSelected(insurer) {
		return {
			type: INSURANCE_SELECTED,
			insurer: insurer
		};
	},
	onVisitReasonChange: function onVisitReasonChange(message) {
		return {
			type: VISIT_REASON_CHANGE,
			message: message
		};
	},
	submitAppointmentRequest: function submitAppointmentRequest(requestData, auth) {
		return (0, _doctifyUtils.createAction)({
			actionType: SUBMIT_REQUEST,
			url: '/appointments',
			method: 'POST',
			data: requestData,
			auth: auth
		});
	},
	validationError: function validationError() {
		return {
			type: VALIDATION_FAILED
		};
	},
	setValidPhone: function setValidPhone(valid) {
		return {
			type: SET_VALID_PHONE,
			valid: valid
		};
	},
	showLogin: function showLogin() {
		return {
			type: SHOW_LOGIN
		};
	},
	loginUpdateEmail: function loginUpdateEmail(email) {
		return {
			type: LOGIN_EMAIL_CHANGE,
			email: email
		};
	},
	rememberMeChecked: function rememberMeChecked(rememberMe) {
		return {
			type: LOGIN_REMEMBER_ME_CHECKED,
			rememberMe: rememberMe
		};
	},
	loginSetValidEmail: function loginSetValidEmail(valid) {
		return {
			type: LOGIN_SET_VALID_EMAIL,
			valid: valid
		};
	},
	loginValidationFailed: function loginValidationFailed() {
		return {
			type: LOGIN_VALIDATION_FAILED
		};
	},
	onClaimNumberChange: function onClaimNumberChange(claimNumber) {
		return {
			type: CLAIM_NUMBER_CHANGE,
			claimNumber: claimNumber
		};
	},
	onPolicyNumberChange: function onPolicyNumberChange(policyNumber) {
		return {
			type: POLICY_NUMBER_CHANGE,
			policyNumber: policyNumber
		};
	},
	setValidClaimNumber: function setValidClaimNumber(valid) {
		return {
			type: SET_VALID_CLAIM_NUMBER,
			valid: valid
		};
	},
	setValidPolicyNumber: function setValidPolicyNumber(valid) {
		return {
			type: SET_VALID_POLICY_NUMBER,
			valid: valid
		};
	}
};

exports.default = BookAppointmentModalActions;


// WEBPACK FOOTER //
// ./components/specialist-page/lib/actions/book-appointment-modal.js